export default __webpack_public_path__ + "static/media/Club_Innovación.c2123642.svg";